// extracted by mini-css-extract-plugin
export default {"image":"McPubXTzFF4qxZG8CdSQ","imageResponsive":"KdT1QCzAdKpCZHqUXX6a"};